const stylesheet = new CSSStyleSheet();stylesheet.replaceSync(``);export default stylesheet;